(function () {
    'use strict';

    angular.module('app', [
        'ngRoute',
        'ngCookies',
        'ngSanitize',
        'uiGmapgoogle-maps',
        'LocalStorageModule',
        'pascalprecht.translate',
        'xeditable',
        'mwl.confirm',
        'ui.bootstrap',
        'ngclipboard',
        'blockUI',
        'ui.tree',
        'ui.select',
        'color.picker',
        'd3',
        '720kb.socialshare',
        'angular.filter',
        'doubleScrollBars',
        'monospaced.qrcode',
        'currencyFormat',
        'textAngular',
        'tmh.dynamicLocale',
        'uiCropper'
    ]).config(config).constant('LANGS', {
        'en': 'English',
        'uk': 'Українська',
        'ru': 'Русский',
        'pl': 'Polski',
        'sk': 'Slovak',
        'fr': 'Français'
    }).filter('abs', function () {
        return function (val) {
            return Math.abs(val);
        };
    }).filter('htmlToPlaintext', function () {
        return function (text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
    }).filter('isValidCouponCode', function () {
        return function (code) {
            return !!code && code.length < 256 && !!new RegExp(/^[A-Za-z\d.\- ]*$/).test(code);
        };
    }).factory('$exceptionHandler', [function ($log) {

        return function errorCatcherHandler(exception, cause) {
            console.error(exception);
            if (Sentry) {
                Sentry.captureException(exception);
            }
        };
    }]).factory('platformParamsTranslateInterpolation', platformParamsTranslateInterpolation).run(run);

    platformParamsTranslateInterpolation.$inject = ['$interpolate'];

    function platformParamsTranslateInterpolation($interpolate) {
        var $locale;

        return {
            setLocale: function (locale) {
                $locale = locale;
            },

            getInterpolationIdentifier: function () {
                return 'custom';
            },

            interpolate: function (string, interpolateParams, context, sanitizeStrategy, translationId) {
                if (interpolateParams === null || interpolateParams === undefined) {
                    interpolateParams = {
                        platform_name: appConfig.platformParams.platform_name[$locale],
                        main_site: appConfig.platformParams.main_site[$locale],
                        client_site: appConfig.platformParams.client_site[$locale],
                        business_site: appConfig.platformParams.business_site[$locale],
                        register_site: appConfig.platformParams.register_site[$locale],
                        support_email: appConfig.platformParams.support_email[$locale]
                    };
                } else {
                    interpolateParams.platform_name = appConfig.platformParams.platform_name[$locale];
                    interpolateParams.main_site = appConfig.platformParams.main_site[$locale];
                    interpolateParams.client_site = appConfig.platformParams.client_site[$locale];
                    interpolateParams.business_site = appConfig.platformParams.business_site[$locale];
                    interpolateParams.register_site = appConfig.platformParams.register_site[$locale];
                    interpolateParams.support_email = appConfig.platformParams.support_email[$locale];
                }
                return $interpolate(string)(interpolateParams, sanitizeStrategy);
            }

        };
    }

    config.$inject = [
        '$routeProvider',
        '$httpProvider',
        '$locationProvider',
        'localStorageServiceProvider',
        '$translateProvider',
        'uiGmapGoogleMapApiProvider',
        'tmhDynamicLocaleProvider',
        'blockUIConfig'
    ];

    function config(
        $routeProvider,
        $httpProvider,
        $locationProvider,
        localStorageServiceProvider,
        $translateProvider,
        GoogleMapApiProviders,
        tmhDynamicLocaleProvider,
        blockUIConfig
    ) {
        tmhDynamicLocaleProvider.localeLocationPattern('/components/angular-i18n/angular-locale_{{locale}}.js');

        angular.lowercase = angular.$$lowercase;
        $httpProvider.defaults.xsrfCookieName = 'csrftoken';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
        //$analyticsProvider.virtualPageviews(false);

        // Google maps
        GoogleMapApiProviders.configure({
            v: '3.24',
            libraries: 'places'
            // key: 'API KEY'  TODO Need Google map key
        });

        //block UI config
        blockUIConfig.autoBlock = false;
        blockUIConfig.templateUrl = 'app/templates/block.ui.html';
        blockUIConfig.delay = 0;

        localStorageServiceProvider.setPrefix('ic').setStorageType('localStorage').setDefaultToCookie(true).setStorageCookie(365, '/', true);

        var FALLBACK_LANGUAGE = 'en';

        // Language settings
        $translateProvider.useStaticFilesLoader({
            prefix: '/app/translate/',
            suffix: '.json?h=' + Math.floor(moment().format('x') / 3600)
        }).fallbackLanguage(FALLBACK_LANGUAGE).registerAvailableLanguageKeys(['en', 'ru', 'uk', 'pl', 'sk', 'fr'], {
            'en*': 'en',
            'ru*': 'ru',
            'uk*': 'uk',
            'pl*': 'pl',
            'sk*': 'sk',
            'fr*': 'fr'
        }).useSanitizeValueStrategy('sceParameters').useLocalStorage().determinePreferredLanguage().useInterpolation('platformParamsTranslateInterpolation');
        tmhDynamicLocaleProvider.defaultLocale(FALLBACK_LANGUAGE);
        var baseStyles = 'admin-panel page-header-fixed page-sidebar-closed-hide-logo page-container-bg-solid page-content-white';

        // Routing settings
        // *
        // use 'bodyStyle' to set view page specific body classes
        // *
        $locationProvider.hashPrefix('');

        $routeProvider.when('/', {
            title: 'Dashboard',
            controller: 'HomeController',
            templateUrl: 'app/pages/home/home.view.html',
            // reloadOnSearch: false,
            bodyStyle: baseStyles
        }).when('/signin', {
            title: 'Log In',
            controller: 'SignInController',
            templateUrl: 'app/pages/signin/signin.view.html',
            reloadOnSearch: false,
            bodyStyle: 'login'
        }).when('/signup', {
            title: 'Sign Up (Free Of Charge)',
            controller: 'SignUpController',
            templateUrl: 'app/pages/signup/signup.view.html',
            bodyStyle: 'login'
        }).when('/transactions', {
            title: 'Log of transactions',
            controller: 'TransactionsController',
            templateUrl: 'app/pages/transactions/transactions.view.html',
            isAllMode: true,
            bodyStyle: baseStyles
        }).when('/transactions-goods', {
            title: 'Log of transactions goods',
            controller: 'TransactionsGoodsController',
            templateUrl: 'app/pages/transactions-goods/transactions-goods.view.html',
            isAllMode: true,
            bodyStyle: baseStyles
        }).when('/orders', {
            title: 'Log of orders',
            controller: 'OrdersController',
            templateUrl: 'app/pages/orders/orders.view.html',
            bodyStyle: baseStyles
        }).when('/taxes', {
            title: 'Log of taxes',
            controller: 'TaxesController',
            templateUrl: 'app/pages/taxes/taxes.view.html',
            bodyStyle: baseStyles
        }).when('/margins', {
            title: 'Log of margins',
            controller: 'MarginsController',
            templateUrl: 'app/pages/margins/margins.view.html',
            bodyStyle: baseStyles
        }).when('/customers/search', {
            title: 'Search customer',
            controller: 'CustomersController',
            templateUrl: 'app/pages/customers/search-customer.page.html',
            bodyStyle: baseStyles
        }).when('/customers/:mode?/:customer_id?/:loyalty_id?', {
            title: 'Customers',
            controller: 'CustomersController',
            templateUrl: 'app/pages/customers/customers.page.html',
            bodyStyle: baseStyles
        }).when('/import/customers', {
            title: 'Import customers',
            controller: 'ImportCustomersController',
            templateUrl: 'app/pages/import/import.customers.view.html',
            bodyStyle: baseStyles
        }).when('/messages', {
            title: 'Messages',
            controller: 'MessagesController',
            templateUrl: 'app/pages/messages/messages.view.html',
            bodyStyle: baseStyles
        }).when('/news/:mode?/:news_id?', {
            title: 'News and info',
            controller: 'NewsController',
            templateUrl: 'app/pages/news/news.view.html',
            bodyStyle: baseStyles
        }).when('/partners', {
            title: 'Reward program',
            controller: 'PartnersController',
            templateUrl: 'app/pages/partners/partners.view.html',
            bodyStyle: baseStyles
        }).when('/support', {
            title: 'Support',
            controller: 'SupportController',
            templateUrl: 'app/pages/support/support.view.html',
            bodyStyle: baseStyles
        }).when('/tariff/:mode?', {
            title: 'My Account',
            controller: 'TariffController',
            templateUrl: 'app/pages/tariff/tariff.view.html',
            bodyStyle: baseStyles
        }).when('/business/:mode?', {
            title: 'Settings',
            controller: 'BusinessController',
            templateUrl: 'app/pages/business/business.view.html',
            bodyStyle: baseStyles
        }).when('/payment/:status?', {
            title: 'Pay on Account',
            controller: 'PaymentController',
            templateUrl: 'app/pages/payment/payment.page.html',
            bodyStyle: baseStyles
        }).when('/thankyou', {
            title: 'Thank You',
            controller: 'ResultController',
            templateUrl: 'app/pages/result/result.view.html',
            bodyStyle: baseStyles
        }).when('/loyalties/:mode?/:loyalty_id?', {
            title: 'Loyalty programs list',
            controller: 'LoyaltiesController',
            templateUrl: 'app/pages/loyalty/loyalties.view.html',
            // reloadOnSearch: false,
            bodyStyle: baseStyles
        }).when('/pos/:mode?/:pos_id?', {
            title: 'Points of sale list',
            controller: 'PointsOfSalesController',
            templateUrl: 'app/pages/pos/pos.view.html',
            reloadOnSearch: false,
            bodyStyle: baseStyles
        }).when('/road-tankers/:mode?/:pos_id?', {
            title: 'Road tankers list',
            controller: 'PointsOfSalesController',
            templateUrl: 'app/pages/pos/pos.view.html',
            reloadOnSearch: false,
            isRoadTankersMode: true,
            bodyStyle: baseStyles
        }).when('/tanks-linked/:mode?', {
            title: 'Tanks linked list',
            controller: 'TanksLinkedController',
            templateUrl: 'app/pages/tanks-linked/tanks-linked.view.html',
            reloadOnSearch: false,
            isRoadTankersMode: true,
            bodyStyle: baseStyles
        }).when('/business-staff/:mode?/:staffId?', {
            title: 'Business staff list',
            controller: 'BusinessStaffController',
            templateUrl: 'app/pages/business-staff/business-staff.page.html',
            reloadOnSearch: false,
            bodyStyle: baseStyles
        }).when('/routes-terminal/:mode?/:routeID?', {
            title: 'Routes terminal list',
            controller: 'RoutesTerminalController',
            templateUrl: 'app/pages/routes-terminal/routes-terminal.view.html',
            reloadOnSearch: false,
            bodyStyle: baseStyles
        }).when('/terminals/:mode?/:terminal_id?', {
            title: 'Registers and salespersons list',
            controller: 'TerminalsController',
            templateUrl: 'app/pages/terminals/terminals.view.html',
            reloadOnSearch: false,
            bodyStyle: baseStyles
        }).when('/road-terminals/:mode?/:terminal_id?', {
            title: 'Registers and salespersons list',
            controller: 'TerminalsController',
            templateUrl: 'app/pages/terminals/terminals.view.html',
            bodyStyle: baseStyles,
            reloadOnSearch: false,
            isRoadTankerDriverMode: true,
            filterType: 'road-tanker-driver'
        }).when('/client-accounts/:mode?/:account_id?', {
            title: 'Customer accounts',
            controller: 'AccountsController',
            templateUrl: 'app/pages/accounts/accounts.page.html',
            bodyStyle: baseStyles
        }).when('/goods-and-services/:mode?/:item_id?', {
            title: 'Goods and services',
            controller: 'GoodsController',
            templateUrl: 'app/pages/goods/goods.view.html',
            isFuelMode: false,
            bodyStyle: baseStyles
        }).when('/fuel-goods/:mode?/:item_id?', {
            title: 'Fuel Goods',
            controller: 'GoodsController',
            templateUrl: 'app/pages/goods/goods.view.html',
            isFuelMode: true,
            bodyStyle: baseStyles
        }).when('/categories/:mode?/:category_id?', {
            title: 'Categories',
            controller: 'CategoriesController',
            templateUrl: 'app/pages/categories/categories.view.html',
            bodyStyle: baseStyles
        }).when('/series/:mode?/:batch_id?', {
            title: 'TEXT_BATCH_LIST_TITLE',
            controller: 'SeriesController',
            templateUrl: 'app/pages/series/series.view.html',
            reloadOnSearch: false,
            bodyStyle: baseStyles
        }).when('/gift-cards/:mode?/:gift_card_id?', {
            title: 'TEXT_GIFT_CARDS_LIST_TITLE',
            controller: 'GiftCardsController',
            templateUrl: 'app/pages/giftcards/giftcards.view.html',
            bodyStyle: baseStyles
        }).when('/coupons', {
            title: 'TEXT_COUPONS_LIST_TITLE',
            controller: 'CouponsController',
            templateUrl: 'app/pages/series/coupons/coupons.view.html',
            bodyStyle: baseStyles
        }).when('/coupons/exchange', {
            title: 'TEXT_BATCH_LIST_TITLE',
            controller: 'SeriesExchangeController',
            templateUrl: 'app/pages/series/exchange/exchange.view.html',
            bodyStyle: baseStyles
        }).when('/prepaid/:mode?/:id?', {
            title: 'TEXT_PREPAID_SERIES_TITLE',
            controller: 'PrepaidController',
            templateUrl: 'app/pages/prepaid/prepaid.view.html',
            bodyStyle: baseStyles
        }).when('/reseller', {
            title: 'Reseller Partners',
            controller: 'ResellerController',
            templateUrl: 'app/pages/reseller/reseller.business.view.html',
            bodyStyle: baseStyles
        })
            // User profile
            .when('/profile', {
                title: 'Profile',
                controller: 'ProfileController',
                templateUrl: 'app/pages/profile/profile.view.html',
                bodyStyle: baseStyles
            }).when('/confirm-email/:token', {
            title: 'Confirm email',
            controller: 'ConfirmEmailController',
            templateUrl: 'app/pages/confirm/confirm.view.html',
            bodyStyle: baseStyles
        }).when('/fuel-controllers/routes', {
            title: 'Fuel Controllers routes',
            controller: 'FuelRoutesController',
            templateUrl: 'app/pages/fuel-controllers/routes/fuel_controllers_routes.view.html',
            bodyStyle: baseStyles,
            reloadOnSearch: false
        }).when('/fuel-controllers/dashboard', {
            title: 'Fuel Controllers dashboard',
            controller: 'FuelDashboardController',
            templateUrl: 'app/pages/fuel-controllers/dashboard/fuel_controllers_dashboard.view.html',
            bodyStyle: baseStyles,
            reloadOnSearch: false
        }).when('/fuel-controllers/:mode?/:loyalty_id?/:controller_id?', {
            title: 'Fuel Controllers',
            controller: 'FuelController',
            reloadOnSearch: false,
            templateUrl: 'app/pages/fuel-controllers/fuel_controllers.view.html',
            bodyStyle: baseStyles
        }).when('/feedback', {
            title: 'Feedback',
            controller: 'FeedbackController',
            templateUrl: 'app/pages/feedbacks/feedbacks.view.html',
            bodyStyle: baseStyles
        }).when('/feedback/sources/:mode?/:feedbackSourceId?', {
            title: 'Feedback Sources',
            controller: 'FeedbackSourcesController',
            templateUrl: 'app/pages/feedbacks/feedbackSources/feedbacks.view.html',
            bodyStyle: baseStyles
        }).when('/feedback/sources/:mode?/loyalty/:loyalty_id?/:feedbackSourceId?', {
            title: 'Feedback Sources',
            controller: 'FeedbackSourcesController',
            templateUrl: 'app/pages/feedbacks/feedbackSources/feedbacks.view.html',
            bodyStyle: baseStyles
        }).when('/feedbacks/sourceId/:feedback_source_id?', {
            title: 'Feedbacks',
            controller: 'FeedbackListController',
            templateUrl: 'app/pages/feedbacks/feedbacksList/feedbacks.view.html',
            bodyStyle: baseStyles
        }).when('/feedbacks/:mode?/:feedback_id?', {
            title: 'Feedbacks',
            controller: 'FeedbackListController',
            templateUrl: 'app/pages/feedbacks/feedbacksList/feedbacks.view.html',
            bodyStyle: baseStyles
        }).when('/feedback/wizard', {
            title: 'Feedback Wizard',
            controller: 'FeedbackWizardController',
            templateUrl: 'app/pages/feedback-wizard/feedback-wizard.view.html',
            bodyStyle: baseStyles
        }).when('/feedback/wizard/signup', {
            title: 'Feedback Wizard Signup',
            controller: 'FeedbackWizardSignupController',
            templateUrl: 'app/pages/feedback-wizard-signup/feedback-wizard-signup.view.html',
            bodyStyle: baseStyles
        }).when('/corporate/transactions', {
            title: 'Log of corporate transactions',
            controller: 'TransactionsController',
            templateUrl: 'app/pages/transactions/transactions.view.html',
            isCorporateMode: true,
            isAllMode: false,
            bodyStyle: baseStyles
        }).when('/corporate/transactions-goods', {
            title: 'Log of corporate transactions goods',
            controller: 'TransactionsGoodsController',
            templateUrl: 'app/pages/transactions-goods/transactions-goods.view.html',
            isCorporateMode: true,
            isAllMode: false,
            bodyStyle: baseStyles
        }).when('/corporate/category', {
            title: 'Corporate users categories',
            controller: 'CorporateAccountsCategoryController',
            templateUrl: 'app/pages/corporates/category/corporate-account-category.view.html',
            isCorporateMode: true,
            bodyStyle: baseStyles
        }).when('/corporate-accounts/:mode?/:account_id?', {
            title: 'Corporate accounts',
            controller: 'CorporateAccountsController',
            templateUrl: 'app/pages/corporates/corporate-accounts/corporate-accounts.page.html',
            bodyStyle: baseStyles
        }).when('/corporate-users/:mode?/:customer_id?/:loyalty_id?', {
            title: 'Corporate users',
            controller: 'CorporateUsersController',
            reloadOnSearch: false,
            templateUrl: 'app/pages/corporates/corporate-users/corporate-users.view.html',
            bodyStyle: baseStyles
        }).when('/corporate', {
            title: 'Corporate',
            controller: 'CorporateAccountsController',
            templateUrl: 'app/pages/corporates/corporate-main/corporate.main.view.html',
            bodyStyle: baseStyles
        }).when('/price-groups/:loyaltyID?/:pageMode?/:priceGroupID?', {
            title: 'Price groups',
            controller: 'PriceGroupsController',
            templateUrl: 'app/pages/price-groups/price-groups.view.html',
            bodyStyle: baseStyles
        }).when('/settings-menu', {
            title: 'Settings menu',
            controller: 'SettingsMenuController',
            templateUrl: 'app/pages/settings-menu/settings-menu.page.html',
            bodyStyle: baseStyles
        }).when('/evs', {
            title: 'External Verification System',
            controller: 'EVSController',
            templateUrl: 'app/pages/evs/evs.page.html',
            bodyStyle: baseStyles
        }).when('/external-forms', {
            title: 'External forms',
            controller: 'ExternalFormsController',
            templateUrl: 'app/pages/external-forms/external-forms.view.html',
            bodyStyle: baseStyles
        }).when('/equipment/:mode?/:controller_id?', {
            title: 'Controllers',
            controller: 'EquipmentController',
            templateUrl: 'app/pages/equipment/equipment.view.html',
            bodyStyle: baseStyles
        })


            // Error
            .otherwise({redirectTo: '/'});

        $locationProvider.html5Mode(true);
    }

    run.$inject = [
        '$rootScope', '$location', '$window', '$timeout', '$translate', 'BusinessService', 'NotifyService',
        'SettingsService', 'UserService', '$uibModal',
        'localStorageService',
        'tmhDynamicLocale'];

    function run($rootScope, $location, $window, $timeout, $translate, BusinessService, NotifyService,
                 SettingsService, UserService, $uibModal,
                 localStorageService,
                 tmhDynamicLocale) {
        $rootScope.LANG = $translate.storage().get();

        function validURL(str) {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return !!pattern.test(str);
        }

        if (appConfig.platformParams.helpcrunch) {
            window.HelpCrunch(
                'init',
                appConfig.platformParams.helpcrunch.appName,
                {
                    applicationId: appConfig.platformParams.helpcrunch.applicationId,
                    applicationSecret: appConfig.platformParams.helpcrunch.applicationSecret
                }
            );
            window.HelpCrunch('showChatWidget');
        }
        document.addEventListener('keyup', function (e) {

            if (e.ctrlKey && e.altKey && e.shiftKey && e.key.toLowerCase() === 'x') {
                var apiBase = prompt('Set custom api domain' + '\n'
                    + 'exemple: https://api.domain.com/v1' + '\n' + 'Or write "remove" to delete custom  api domain', '');

                if (apiBase) {
                    if (validURL(apiBase)) {
                        try {
                            localStorage.apiBase = apiBase;
                            alert('Success set domain.' + '\n' + 'This page will be reloaded');
                            location.reload();
                        } catch (e) {
                        }

                    } else if (apiBase == 'remove') {
                        try {
                            if (localStorage) {
                                delete localStorage.apiBase;
                                location.reload();
                            }
                        } catch (e) {
                        }
                    } else {
                        alert('This domain is invalid');
                    }
                }

            }

        }, false);
        if ($rootScope.USER &&
            $rootScope.USER.Authorized &&
            $location.$$search &&
            $location.$$search.admin &&
            $location.$$search.login !== $rootScope.USER.phone) {

            UserService.Logout($location.$$search.admin, $location.$$search.login);
        }
        initENV();
        console.log('getBusiness() 1');
        getBusiness();
        $rootScope.csrf_token = (Math.random() * 10000).toString(36);
        $rootScope.PAGE = {
            title: '',
            style: null,
            events: []
        };

        $rootScope.SERVICE_LINKS = {};
        $rootScope.PLATFORM_PARAMS;

        $rootScope.Logout = UserService.Logout;

        $rootScope.getLangULR = getLocalizedPathFromLang;

        // Store all "un bind" functions to array
        $rootScope.onEvent = function (name, callback) {
            $rootScope.PAGE.events.push(
                $rootScope.$on(name, callback)
            );
        };

        $rootScope.$on('user-login', function () {
            initENV();
        });

        $rootScope.$on('user-register', function () {
            initENV();
        });

        $rootScope.$on('$translateChangeSuccess', function () {
            $rootScope.LANG = $translate.use();
            tmhDynamicLocale.set($rootScope.LANG);
            console.info('TranslateService $translateChangeSuccess', $rootScope.LANG);
        });

        /**
         * Router selected. Listen for get page title
         */
        $rootScope.$on('$routeChangeSuccess', function (event, current, previous) {
            console.info('$routeChangeSuccess', current);

            $rootScope.fixContenTheight();

            // Remove all listeners from previous page
            $rootScope.PAGE.events.forEach(function (item) {
                item();
            });
            $rootScope.PAGE.events = [];

            // Set current page settings
            if (current.$$route) {
                $rootScope.PAGE.title = current.$$route.title;
                $rootScope.PAGE.appName = $rootScope.appConfig.platformParams.platform_name.en;
                $rootScope.PAGE.style = current.$$route.bodyStyle;
            }

            $window.scrollTo(0, 0);
        });

        /**
         * Redirect to login page if not logged in and trying to access a restricted page
         */
        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            console.info('on.locationChangeStart', $location);

            var isPublicPage = $.inArray($location.path(), ['/signin', '/signup']) > -1;
            var isFeedbackWizardPage = $location.path().indexOf('/feedback/wizard') !== -1;
            var isFeedbackWizardSignupPage = $location.path().indexOf('/feedback/wizard/signup') !== -1;
            var isConfirmation = $location.path().indexOf('/confirm-email') !== -1;

            if (!$rootScope.TARIFF_LIMITATION)
                $rootScope.TARIFF_LIMITATION = {};

            if ($rootScope.USER && $rootScope.USER.Authorized) {
                if (isPublicPage) {
                    $location.path('/');
                } else if (isFeedbackWizardSignupPage) {
                    $location.path('/feedback/wizard');
                }
            } else {
                if (isFeedbackWizardPage) {
                    $location.path('/feedback/wizard/signup');
                } else if (!isPublicPage && !isConfirmation) {
                    $rootScope.redirectToSignIn();
                }
            }

            if ($rootScope.USER && $rootScope.USER.Authorized) {
                if (!$rootScope.ENV.business || !$rootScope.ENV.business.country) {
                    console.log('getBusiness() 1');
                    getBusiness();
                }

                $rootScope.getBusinessStatus(function () {
                    $rootScope.initSidebarMenu();
                });

                $rootScope.getCountries(function (success, data) {
                });
            }

        });

        /**
         * Set global processing of Native API errors
         */
        $rootScope.$on('api_response_error', function (event, response) {
            console.info('on.api_response_error', response);
            switch (response.data.code) {
                case 3: // Incorrect token
                    $rootScope.redirectToSignIn(true);
                    break;
                case 36:
                    $rootScope.redirectToPayment();
                    break;

                case 30: // Business not found
                    $rootScope.ENV.businessNotExist = true;
                    if ($location.path().indexOf('/feedback') !== -1) {
                        $location.path('/feedback/wizard');
                    } else if ($location.path().indexOf('/confirm-email') === -1) {
                        $location.path('/business/create');
                    }
                    break;
            }
        });

        function initENV() {
            $rootScope.ENV = {
                decimal_digits: 2,
                business: {
                    status: {}
                },
                filters: {},
                tools: {
                    storage_suffix: '_16'
                },
                settings: {}
            };

            var stored_env = localStorageService.get('env');
            if (stored_env) {
                var env = JSON.parse(stored_env);
                for (var i in env)
                    $rootScope.ENV[i] = angular.copy(env[i]);
            }
        }

        function getBusiness() {
            if ($rootScope.USER && $rootScope.USER.Authorized) {
                BusinessService.GetWithTariff(function (success, response) {
                    console.log('getBusiness()', response);
                    if (success) {
                        // emit event to update sidebar when some submenu is turn on/of
                        $rootScope.$emit('SIDEBAR_CHECK_ON_OPTIONS', response);
                        delete response.auto_pay_params;

                        var tl = {
                            special_accounts_processing: false,
                            change_customer_questionnaire: false,
                            use_advanced_customer_filters: false,
                            use_gift_cards: false,
                            analytics_available: false,
                            active_customer_categories_number: 0,
                            active_loyalty_rules_number: 0,
                            use_coupon_exchange: false,
                            use_coupons_and_certificates: false,
                            export_transactions_list: false,
                            mobile_app_publishing: false,
                            integration_with_pos: false,
                            mobile_app_main_page_news: false
                        };

                        for (var i in tl)
                            if (i === 'active_customer_categories_number' || i === 'active_loyalty_rules_number')
                                tl[i] = response.tariff[i];
                            else if (response.tariff[i] === 0)
                                tl[i] = true;
                            else if (response.tariff[i] === 1)
                                tl[i] = false;

                        $rootScope.TARIFF_LIMITATION = tl;

                        $rootScope.ENV.business = response;
                        $rootScope.storeENV();
                        UserService.reNewToken(function (success) {
                            if (appConfig.platformParams.helpcrunch) {
                                window.HelpCrunch('setPhraseList', $rootScope.LANG);
                                var user = {
                                    email: $rootScope.USER.login,
                                    name: $rootScope.USER.name,
                                    company: $rootScope.USER.name,
                                    user_id: response.code,
                                    phone: $rootScope.USER.phone
                                };
                                window.HelpCrunch('userAuth', user);
                            }
                        });

                        if(
                            $rootScope.ENV.business.status.flag_tariff_plan_expired ||
                            $rootScope.ENV.business.status.flag_insufficient_funds_on_account
                        ) {
                            var p = $location.path('/payment');
                            var currentPath = $location.path();
                            if (currentPath && currentPath !== p) {
                                p.search({redirect: currentPath});
                            }
                        }
                    }
                });
            }
        }

        $rootScope.fixContenTheight = function () {
            $timeout(function () {
                var element_page_content = angular.element(document.getElementById('page-content')),
                    element_page_sidebar = angular.element(document.getElementById('page-sidebar-scroll-wrapper'));

                if (element_page_content.prop('offsetHeight') < $window.innerHeight)
                    element_page_content.css('min-height', ($window.innerHeight - 80) + 'px');
            }, 0, false);
        };

        /**
         * Store environment parameters to cookies
         */
        $rootScope.storeENV = function () {
            localStorageService.set('env', JSON.stringify($rootScope.ENV));
        };

        /**
         * Redirect to "Sign in" page with "redirect" parameter for follow back after authorization
         */
        $rootScope.redirectToSignIn = function (is_logout, error) {
            var currentPath = $location.path();
            if (is_logout) UserService.Logout();
            if ($rootScope.USER) $rootScope.USER.Authorized = false;
            var p = $location.path('/signin');

            if (currentPath && currentPath != p) {
                p.search({redirect: currentPath, message: error && error.message ? error.message : null});
            }
        };

        $rootScope.redirectToPayment = function () {
            var currentPath = $location.path();
            var p = $location.path('/payment');

            if (currentPath && currentPath !== p) {
                p.search({redirect: currentPath,});
            }
        };

        $rootScope.getBusinessStatus = function (callback) {
            BusinessService.GeneralStatus(function (success, response) {
                if (success) {
                    if (!$rootScope.ENV.business)
                        $rootScope.ENV.business = {status: {}};

                    if (!$rootScope.ENV.tools)
                        $rootScope.ENV.tools = {storage_suffix: '_15'};

                    $rootScope.ENV.business.status = response;
                    $rootScope.storeENV();
                }
                if (callback) {
                    callback();
                }
            });
        };
        // https://docs.google.com/document/d/1AqVh4k-n0NVIsJQ6ubtba-i0oiXkh3kiwWYI3fYy13g/
        $rootScope.DEFAULT_MENU_JSON = menuJson;
        console.log('DEFAULT_MENU_JSON', $rootScope.DEFAULT_MENU_JSON);

        $rootScope.MENU_BY_TARIFF = angular.copy($rootScope.DEFAULT_MENU_JSON);

        $rootScope.DEFAULT_MENU = angular.copy($rootScope.DEFAULT_MENU_JSON);

        $rootScope.getDefaultMenu = function () {
            return angular.copy($rootScope.DEFAULT_MENU);
        };

        $rootScope.setDefaultMenu = function (DEFAULT_MENU) {
            console.log('setDefaultMenu', DEFAULT_MENU);
            return $rootScope.DEFAULT_MENU = DEFAULT_MENU;
        };

        /**
         * По умолчанию у нас все доступно и включено
         * (условно держим что у каждого меню есть свойства hidden = false и disabled = false)
         * 1. С начало берем настройки у пользователя и применяем его сортировку и свойство hidden
         * 2. Потом берем настройки с платформы и собираем только те модули которые выключены и скрыты
         * 3. применяем значение к нашему меню
         */

        $rootScope.MENU_ITEMS = null;
        $rootScope.initSidebarMenu = function () {
            var newItemsMenu = angular.copy($rootScope.DEFAULT_MENU_JSON);

            SettingsService.GetPlatformModulesBusinessPreferences(function (success, data) {

                if (success && data && data.menu) {
                    // К данному тарифу есть пресет где может быть меню

                    // дефолтное меню разложить в одно уровневый массив
                    var flattenDefaultMenu = flattenMenu(angular.copy($rootScope.DEFAULT_MENU_JSON), 'sub');

                    var patchMenuBySettings = function (items, flattenDefaultItemsOrdering) {

                        var defaultKeyGuard = (flattenDefaultItemsOrdering || []).map(function (o) {
                            return o.keyGuard;
                        });
                        return (items || [])
                            // фильтруем только те которые есть в дефолтном меню
                            .filter(function (item) {
                                return defaultKeyGuard.indexOf(item.keyGuard) !== -1;
                            }).map(function (settingsItem) {

                                var defaultItem = flattenDefaultItemsOrdering.find(function (defaultItem) {
                                    return defaultItem.keyGuard === settingsItem.keyGuard;
                                });
                                if (defaultItem) {
                                    defaultItem.available = settingsItem.available;
                                    defaultItem.visible = settingsItem.visible;
                                    defaultItem.disabled = !!settingsItem.available;
                                    defaultItem.hidden = !!settingsItem.visible;
                                }
                                delete defaultItem.sub;

                                if(
                                    $rootScope.ENV.business.status.flag_tariff_plan_expired ||
                                    $rootScope.ENV.business.status.flag_insufficient_funds_on_account
                                ) {
                                    if(
                                        defaultItem.href !== '/tariff' ||
                                        defaultItem.href !== '/tariff/details' ||
                                        defaultItem.href !== '/payment'
                                    ) {
                                        defaultItem.disabled = true;
                                    }

                                }

                                if (settingsItem.sub) {
                                    defaultItem.sub = patchMenuBySettings(settingsItem.sub, flattenDefaultItemsOrdering, true);
                                }

                                return defaultItem;
                            });

                    };
                    newItemsMenu = patchMenuBySettings(data.menu, flattenDefaultMenu, false);

                    $rootScope.setDefaultMenu(newItemsMenu);
                }

                BusinessService.GetSettingMenu(function (success, data) {
                    console.log('GetSettingMenu', success, data);
                    if (success) {

                        // дефолтное меню разложить в одно уровневый массив
                        var flattenDefaultMenu = flattenMenu(newItemsMenu, 'sub');
                        if (success && data && data.value && data.value.itemsOrdering) {

                            var patchMenuBySettings = function (items, flattenDefaultItemsOrdering) {

                                var defaultKeyGuard = (flattenDefaultItemsOrdering || []).map(function (o) {
                                    return o.keyGuard;
                                });
                                return (items || [])
                                    // фильтруем только те которые есть в дефолтном меню
                                    .filter(function (item) {
                                        return defaultKeyGuard.indexOf(item.keyGuard) !== -1;
                                    }).map(function (settingsItem) {

                                        var defaultItem = flattenDefaultItemsOrdering.find(function (defaultItem) {
                                            return defaultItem.keyGuard === settingsItem.keyGuard;
                                        });
                                        if (defaultItem) {
                                            defaultItem.hidden = settingsItem.hidden;
                                        }
                                        delete defaultItem.sub;
                                        if (settingsItem.sub) {
                                            defaultItem.sub = patchMenuBySettings(settingsItem.sub, flattenDefaultItemsOrdering, true);
                                        }

                                        return defaultItem;
                                    });

                            };
                            newItemsMenu = patchMenuBySettings(data.value.itemsOrdering, flattenDefaultMenu, false);

                        }

                        // !!!! TODO новые пункты меню надо добавить ....
                        var flattenNewMenu = flattenMenu(newItemsMenu, 'sub');

                        flattenMenu(angular.copy($rootScope.DEFAULT_MENU_JSON), 'sub').forEach(function (defaultItem) {
                            var isItem = flattenNewMenu.find(function (newItem) {
                                return newItem.keyGuard === defaultItem.keyGuard;
                            });
                            console.log('defaultItem', defaultItem, isItem);
                            if (!isItem) {
                                if (defaultItem.sub) {
                                    delete defaultItem.sub;
                                }
                                newItemsMenu.push(defaultItem);
                            }
                        });

                        setPosAndTerminalsVisibilityNew(newItemsMenu);
                    }

                    $rootScope.MENU_ITEMS = newItemsMenu;
                    //$rootScope.setDefaultMenu(newItemsMenu);
                });

            });

        };

        function setPosAndTerminalsVisibilityNew(newItemsMenu) {
            // TODO change to find
            deepMap((angular.copy(newItemsMenu) || []), function (item) {

                if (item.keyGuard === 'pos') {
                    $rootScope.isPosBlockVisible = !item.disabled && !item.hidden;
                }

                if (item.keyGuard === 'terminals') {
                    $rootScope.isTerminalsBlockVisible = !item.disabled && !item.hidden;
                }

                return item;
            }, 'sub');
        }

        function setPosAndTerminalsVisibility() {
            if ($rootScope.MENU_ITEMS) {
                var pageSettings = $rootScope.MENU_ITEMS.find(function (item) {
                    return item.keyGuard === 'business';
                });
                if (pageSettings && pageSettings.sub) {
                    var posItem = pageSettings.sub.find(function (item) {
                        return item.keyGuard === 'pos';
                    });
                    if (posItem) {
                        $rootScope.isPosBlockVisible = !posItem.disabled && !posItem.hidden;
                    } else {
                        $rootScope.isPosBlockVisible = true;
                    }
                    var terminalsItem = pageSettings.sub.find(function (item) {
                        return item.keyGuard === 'terminals';
                    });
                    if (terminalsItem) {
                        $rootScope.isTerminalsBlockVisible = !terminalsItem.disabled && !terminalsItem.hidden;
                    } else {
                        $rootScope.isTerminalsBlockVisible = true;
                    }
                }
            }
        }

        function applyDeniedMenu(itemsMenu, denied, invisible) {

            itemsMenu.forEach(function (item) {
                if (!!denied) {
                    item.disabled = (Object.keys(denied) || []).indexOf(item.keyGuard || '') !== -1;
                }
                if (!!invisible && typeof item.hidden !== 'boolean') {
                    item.hidden = ((Object.keys(invisible) || []).indexOf(item.keyGuard || '') !== -1);
                }
                if (item.sub) {
                    item.sub = applyDeniedMenu(item.sub, denied, invisible);
                }
            });

            return itemsMenu;
        }

        $rootScope.getBusinessSettings = function () {
            BusinessService.Settings(function (success, response) {
                if (success) {
                    if (!$rootScope.ENV.business)
                        $rootScope.ENV.business = {settings: {}};

                    if (!$rootScope.ENV.tools)
                        $rootScope.ENV.tools = {storage_suffix: '_15'};

                    $rootScope.ENV.business.settings = response;
                    $rootScope.storeENV();
                }
            });
        };

        $rootScope.getCountries = function (callback) {
            if (!$rootScope.ENV.countries)
                $rootScope.ENV.countries = [];

            if ($rootScope.ENV.countries[$rootScope.LANG]) {
                callback(true, $rootScope.ENV.countries[$rootScope.LANG]);
            } else {
                SettingsService.Countries(function (success, data) {
                    if (success) {
                        if ($rootScope.ENV.countries)
                            $rootScope.ENV.countries[$rootScope.LANG] = $rootScope.COUNTRIES[$rootScope.LANG];

                        $rootScope.storeENV();
                    }
                    callback(success, data);
                });
            }
        };

        $rootScope.onMailConfirmationResend = function () {
            UserService.RequestConfirmEmail($rootScope.USER.login, function (success, response) {
                if (success) {
                    NotifyService.Success('Sent', false);
                }
            });
        };

        $rootScope.paramsQueryStore = function (name, params) {
            localStorageService.set(name, JSON.stringify(params));
        };

        $rootScope.paramsQueryGet = function (name) {
            var params = localStorageService.get(name);
            if (params)
                return JSON.parse(params);
            else
                return null;
        };

        $rootScope.paramsQueryClean = function (name) {
            localStorageService.remove(name);
        };

        $rootScope.onSendMessageToIncust = function (msg) {
            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: true,
                templateUrl: 'app/templates/modal.messages.sendmessage.html',
                controllerAs: 'popup',
                controller: function ($scope, $uibModalInstance) {
                    var popup = this;

                    popup.target = 'incust';
                    popup.message = msg ? msg : '';

                    popup.onReplySend = function () {
                        var post_data = {
                            message: popup.message
                        };
                        if (!popup.isMessageSent)
                            BusinessService.SendMessageToIncust(post_data, function (success, response) {
                                if (success) {
                                    popup.isMessageSent = true;
                                }
                            });
                        else {
                            $uibModalInstance.close();
                        }
                    };

                    popup.onReplyCancel = function () {
                        $uibModalInstance.close();
                    };

                    popup.showMessages = function () {
                        $location.path('/messages');
                        $uibModalInstance.close();
                    };
                }
            });
        };

        $rootScope.$watchCollection('[BUSINESS.country, appConfig.showKSBage]', function (newCollection, oldCollection) {
            var c = newCollection[0],
                s = newCollection[1],
                u = $rootScope.USER;

            if (c && c === 'UA' && s && u) {
                if ($rootScope.ENV)
                    $rootScope.ENV.ks_branded = false;
                else
                    $rootScope.ENV = {ks_branded: false};

                $rootScope.storeENV();
            }
        });

    }

})();
